import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AccountModule, AccountState} from './modules/AccountModule';
import {LocalizationModule, LocalizationState} from './modules/LocalizationModule';
import {NutrientsModule, NutrientsState} from './modules/NutrientsModule';

Vue.use(Vuex);

export const strict = true;

export type StoreState = {
  LocalizationModule: LocalizationState,
  AccountModule: AccountState,
  NutrientsModule: NutrientsState
};

// @ts-ignore
const store: Store<StoreState> = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    AccountModule,
    // CustomersModule,
    // PartnersModule,
    LocalizationModule,
    NutrientsModule,
  },
});

export default store;
